import React, { PropsWithChildren } from 'react';

import { useBreakpoint } from '@ast/magma/breakpoints';

import { Dialog, DialogButtonType } from '@ast/magma/components/dialog/dialog';

export interface TermsPopupLabels {
  readonly declineText: string;
  readonly acceptText: string;
  readonly termsAndConditionsText: string;
  readonly closeTermsAndConditionsAriaText: string;
}

export interface TermsPopupProps {
  readonly onCloseCallback: (agreed: boolean | null) => void;
  readonly labels: TermsPopupLabels;
}

export const TermsPopup: React.FC<PropsWithChildren<TermsPopupProps>> = ({
  children,
  onCloseCallback,
  labels,
}) => {
  const isMobile = useBreakpoint().device === 'mobile';
  const onClose = (button: DialogButtonType) => {
    onCloseCallback(button === DialogButtonType.Close
      ? null
      : button === DialogButtonType.OK);
  };

  return (
    <Dialog
      align={isMobile ? 'bottom' : 'center'}
      buttons={[
        {
          label: labels.declineText,
          type: DialogButtonType.Cancel,
        },
        {
          label: labels.acceptText,
          type: DialogButtonType.OK,
        },
      ]}
      defaultButton={DialogButtonType.OK}
      onClose={onClose}
      predefinedWidth="md"
      title={labels.termsAndConditionsText}
      showClose={{
        'aria-label': labels.closeTermsAndConditionsAriaText,
      }}
    >
      {children}
    </Dialog>
  );
};
